// extracted by mini-css-extract-plugin
export default {"translateIn":"accordionBody_translateIn__k8KMW","translateOut":"accordionBody_translateOut__OfjP2","expand":"accordionBody_expand__Hh-nm","collapse":"accordionBody_collapse__Jwxh+"};